import Vue from 'vue'
import Router from 'vue-router'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/index',
    }, {
      path: '/index',
      name: 'index',
      component: () => import('@/views/Index'),
      meta: {
        title: '首页',
        notLogin: true,
      }
    }, {
      path: '/about',
      name: 'about',
      component: () => import('@/views/about/About'),
      meta: {
        title: '比赛说明',
        notLogin: true,
      }
    }, {
      path: '/myInfo',
      name: 'myInfo',
      component: () => import('@/views/myInfo/MyInfo'),
      meta: {
        title: '我的信息',
      }
    }, {
      path: '/entry',
      name: 'entry',
      component: () => import('@/views/entry/Index'),
      meta: {
        title: '我要报名'
      }
    },
    {
      path: '/enroll',
      name: 'enroll',
      component: () => import('@/views/enroll/Index'),
      meta: {
        title: '报名结束'
      }
    }
    ,
    {
      path: '/works',
      name: 'works',
      component: () => import('@/views/works/Index'),
      meta: {
        title: '我的作品',
        keepAlive: true,
      }
    }, {
      path: '/works/detail',
      name: 'workDetail',
      component: () => import('@/views/works/Detail'),
      meta: {
        title: '作品详情',
      }
    }, {
      path: '/works/edit',
      name: 'workEdit',
      component: () => import('@/views/works/Edit'),
      meta: {
        title: '编辑作品',
      }
    }, {
      path: '/review',
      name: 'review',
      component: () => import('@/views/review/Index'),
      meta: {
        title: '评审作品'
      }
    }, {
      path: '/review/detail',
      name: 'reviewDetail',
      component: () => import('@/views/review/Detail'),
      meta: {
        title: '查看作品'
      }
    }, {
      path: '/login',
      name: 'login',
      component: () => import('@/views/account/Pingweidl'),
      meta: {
        title: '评委登录',
        notLogin: true,
      }
    }, {
      path: '/result',
      name: 'result',
      component: () => import('@/views/result/Index'),
      meta: {
        title: '我的成绩',
        keepAlive: true,
      }
    }, {
      path: '/certificate',
      name: 'certificate',
      component: () => import('@/views/certificate/index'),
      meta: {
        title: '证书验证'
      }
    }, {
      path: '/prize',
      name: 'prize',
      component: () => import('@/views/certificate/prize'),
      meta: {
        titile: '奖'
      }
    }
  ],
  linkActiveClass: 'active'
})


router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (!to.meta.notLogin) {
    let token = localStorage.getItem('loginToken') || '';
    let timestamp = (new Date()).getTime();
    let expires = localStorage.getItem('tokenExpires') || 0;
    if ((token && expires > timestamp) || to.name == 'result'||to.name=='prize') {
      // console.log("router.islogin");
      next()
    } else {
      next({ path: '/index' })
    }
  } else {
    next()
  }

});

router.afterEach(() => {
  // NProgress.done()
  // console.log("router end");
})


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js